import Fraction from './fraction.js'
import {Operation} from './base.js'

const zero = new Fraction(0);
const one = new Fraction(1);
const minus = new Fraction(-1);

export class Matrix{
  constructor(rows,cols,aug=-1){
    this.rows = rows;
    this.cols = cols;
    this.aug = aug;
    this.matrix = [];
    this.tmpRows = [];
  }
  copyMatrix(){
    const m = [];
    for(const row of this.matrix){
      const newrow = [];
      for(const elem of row){
	newrow.push(elem);
      }
      m.push(newrow);
    }
    return m;
  }
  apply(op){
    const result = new Matrix(this.rows,this.cols,this.aug);
    result.matrix = this.copyMatrix();
    if(op.type == 'mult'){
      for(let k=0; k<this.cols; k++){
	result.matrix[op.mult_i][k] = this.matrix[op.mult_i][k].mul(op.coeff);
      }
    }else if(op.type == 'swap'){
      for(let k=0; k<this.cols; k++){
	result.matrix[op.swap_i1][k] = this.matrix[op.swap_i2][k];
	result.matrix[op.swap_i2][k] = this.matrix[op.swap_i1][k];
      }
    }else if(op.type == 'add'){
      for(let k=0; k<this.cols; k++){
	result.matrix[op.add_i2][k] = this.matrix[op.add_i2][k].add(this.matrix[op.add_i1][k].mul(op.coeff));
      }
    }
    return result;      
  }
  beforeApply(op){
    this.tmpRows.splice(0);
    if(op.type == 'mult'){
      const row = [];
      for(let k=0; k<this.cols; k++){
	row.push(this.matrix[op.mult_i][k].mul(op.coeff));
      }
      this.tmpRows.push(row);
    }else if(op.type == 'add'){
      const row = [];
      for(let k=0; k<this.cols; k++){
	row.push(this.matrix[op.add_i1][k].mul(op.coeff));
      }
      this.tmpRows.push(row);
      const row2 = [];
      for(let k=0; k<this.cols; k++){
	row2.push(this.matrix[op.add_i2][k].add(row[k]));
      }
      this.tmpRows.push(row2);
    }
  }
  get reduced(){
    let pos = -1;
    for(let i=0;i<this.rows;i++){
      let p=this.matrix[i].findIndex( (e) => ! e.equals(zero) );
      if(p != -1){
	if(p <= pos || ! this.matrix[i][p].equals(one) ||
	   this.matrix.some( (e,j) => (i != j && ! e[p].equals(zero)) ) ){
	  return false;
	}
	pos = p;
      }else{
	pos = Infinity;
      }
    }
    return true;
  }
  get hint(){
    const obj = {
      txt: '',
      r1: -1,
      c1: -1,
      r2: -1,
      c2: -1,
      actions: []
    }
    let i=0;
    for(let j=0; j<this.cols; j++){
      const column = this.matrix.map( r => r[j] );
      if(column.slice(i).every( e => e.equals(zero) )){
	continue;
      }else if(! column[i].equals(one)){
	const ar = [];
	if(column[i].equals(minus)){
	  const op = new Operation('mult',1,'row',i,0);
	  op.coeff_mult.input = '-1';
	  ar.push(op);
	}
	for(let k=i+1;k<this.rows;k++){
	  if(column[k].equals(one)){
	    ar.push(new Operation('swap',1,'row',i,k));
	  }
	}
	if(column[i].d == 1){
	  for(let k=i+1;k<this.rows;k++){
	    if(column[k].d == 1 && column[k].n != 0 && (column[i].n*column[i].s-1) % column[k].n*column[k].s == 0){
	      const op = new Operation('add',1,'row',k,i);
	      op.coeff_add.input = `${-(column[i].n*column[i].s -1) / column[k].n*column[k].s}`;
	      ar.push(op);
	    }
	  }	    
	}
	if(! column[i].equals(zero) && ! column[i].equals(minus)){
	  const op = new Operation('mult',1,'row',i,0);
	  op.coeff_mult.input = column[i].inverse().toFraction();
	  ar.push(op);
	}
	for(let k=i+1;k<this.rows;k++){
	  if(column[k].equals(minus)){
	    ar.push(new Operation('swap',1,'row',i,k));
	  }
	}
	if(ar.length < 2 && ! column[i].equals(minus) && column[i].d == 1){
	  for(let k=i+1;k<this.rows;k++){
	    if(column[k].d == 1 && column[k].n != 0 && (column[i].n*column[i].s +1) % column[k].n*column[k].s == 0){
	      const op = new Operation('add',1,'row',k,i);
	      op.coeff_add.input = `${-(column[i].n*column[i].s +1) / column[k].n*column[k].s}`;
	      ar.push(op);
	    }
	  }	    
	}
	if(ar.length < 2 && ! column[i].equals(minus)){
	  for(let k=i+1;k<this.rows;k++){
	    if(column[k].d == 1 &&
	       column.some( (e,l) => l >= i && l != k && column[l].d == 1 && column[l].n != 0
			    && (column[k].n*column[k].s-1) % column[l].n*column[l].s == 0) ){
	      ar.push(new Operation('swap',1,'row',i,k));
	    }
	  }	    
	}
	if(ar.length < 2 && ! column[i].equals(minus) ){
	  for(let k=i+1;k<this.rows;k++){
	    if(column[k].d == 1 &&
	       column.some( (e,l) => l >= i && l != k && column[l].d == 1 && column[l].n != 0
			    && (column[k].n*column[k].s+1) % column[l].n*column[l].s == 0) ){
	      ar.push(new Operation('swap',1,'row',i,k));
	    }
	  }	    
	}
	if(ar.length == 0){
	  for(let k=i+1;k<this.rows;k++){
	    if(! column[k].equals(zero)){
	      ar.push(new Operation('swap',1,'row',i,k));
	    }
	  }
	}
	return {
	  txt: `(${i+1},${j+1})成分を1にする。`,
	  r1: i,
	  c1: j,
	  r2: -1,
	  c2: -1,
	  actions: ar
	};
      }else if(column.every( (e,k) => (e.equals(zero) || k == i))){
	i+=1;
	continue;
      }else{
	const k = column.findIndex( (e,k) => ! (e.equals(zero) || k == i) );
	const op = new Operation('add',1,'row',i,k);
	op.coeff_add.input = column[k].neg().toFraction();
	return {
	  txt: `(${k+1},${j+1})成分を0にする。`,
	  r1: k,
	  c1: j,
	  r2: i,
	  c2: j,
	  actions: [op]
	};	
      }
    }
    return null;
  }
}
